import React, { Component } from 'react';
import { connect } from 'react-redux';
import ScheduleCalendarView from '../components/ScheduleCalendarView';

class ViewScheduleProgram extends Component {
    render() {
        return <ScheduleCalendarView {...this.props} />;
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(ViewScheduleProgram);
